import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
//import { TSubLedgerTran } from "./../interfaces/TrnMain";
import { TSubLedger } from './../interfaces/TrnMain';
// import { JournalService } from "./../journal/journal.service";
//import { IncomeVoucherService } from "./incomevoucher.services";
import { SettingService } from './../services/setting.service';
import { PREFIX } from './../interfaces/Prefix.interface';
import { Router, ActivatedRoute } from '@angular/router';
//import { Item } from './../interfaces/ProductItem';
import { TAcList } from './../interfaces/Account.interface';
import {
  TrnMain,
  TrnProd,
  Trntran,
  CostCenter,
  VoucherTypeEnum,
} from './../interfaces/TrnMain';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MasterRepo } from './../repositories/masterRepo.service';
// import { IDivision } from './../interfaces';
//import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
// import { MdDialogRef, MdDialog } from "@angular/material";
// import { MessageDialog } from "../../../modaldialogs/messageDialog/messageDialog.component";
// import { LoginDialog } from "../../../modaldialogs/index";
import { TransactionService } from './transaction.service';
import { map } from 'rxjs/operators';
declare var $: JQueryStatic;

@Component({
  selector: 'trnmain-voucher-entry',
  templateUrl: './trnmain-voucher-entry.component.html',
  styleUrls: ['../../pages/Style.css'],
})
export class TrnMainVoucherEntryComponent {
  TrnMainObj: TrnMain = <TrnMain>{};
  TrnTranList: Trntran[] = [];
  divisionList: any[] = [];
  voucherType: VoucherTypeEnum = VoucherTypeEnum.PaymentVoucher;
  accountList: TAcList[] = [];
  cashAndBankList: TAcList[] = [];
  Suppliers: TAcList[] = [];
  Customers: TAcList[] = [];
  cashList: TAcList[] = [];
  bankList: TAcList[] = [];
  acList: TAcList[] = [];
  trnaccountList: TAcList[] = [];
  subledgerDropDownList: TSubLedger[] = [];
  prefix: PREFIX = <PREFIX>{};
  TrnMainForm: FormGroup = this._fb.group({
    TRNMODE: ['', Validators.required],
    TRNAC: ['', Validators.required],
    BILLTO: ['', Validators.required],
    CHEQUENO: ['', Validators.required],
    CHEQUEDATE: ['', Validators.required],
    REMARKS: [''],
  });
  private enableDateChange = false;
  viewMode = false;
  private showWholeSubledger = true;
  private subcriptions: Array<Subscription> = [];
  cashAccountSubject: BehaviorSubject<TAcList[]> = new BehaviorSubject<
    TAcList[]
  >([]);
  cashAccountObserver$: Observable<TAcList[]> =
    this.cashAccountSubject.asObservable();
  accountListSubject: BehaviorSubject<TAcList[]> = new BehaviorSubject<
    TAcList[]
  >([]);
  accountListObersver$: Observable<TAcList[]> =
    this.accountListSubject.asObservable();

  constructor(
    public masterService: MasterRepo,
    private _transactionService: TransactionService,
    private router: Router,
    private arouter: ActivatedRoute,
    private _fb: FormBuilder,
    private settingService: SettingService
  ) {
    this.TrnMainObj = this._transactionService.TrnMainObj;
    this.voucherType = this.TrnMainObj.VoucherType;
    if (this.TrnTranList.length == 0) {
      var nulltt = <Trntran>{};
      nulltt.AccountItem = <TAcList>{};
      nulltt.ROWMODE = 'new';
      this.TrnTranList.push(nulltt);
    }

    this.showWholeSubledger =
      this.settingService.appSetting.enableSubLedger ?? false;
    //this.hasCostCenter = this.settingService.appSetting.enableCostCenter;
    //this.hasCheque = this.settingService.appSetting.enableChequeInEntry;
    //this.enableACCodeFocus = this.settingService.appSetting.enableACCodeFocus;
    //this.enableACNameFocus = this.settingService.appSetting.enableACNameFocus;
    console.log({ journalConstructor: 'loading accountlist' });
    //this.masterService.refreshAccountList('Journal-constructor');
    this.masterService
      .getAccount('IncomeVoucher')
      .pipe(
        map((data: any) => {
          var fil = data.filter(
            (ac: any) => ac.MAPID == 'C' || ac.MAPID == 'B'
          );
          return fil;
        })
      )
      .subscribe((res: Array<TAcList>) => {
        this.cashAccountSubject.next(res);
      });
  }

  ngOnInit() {
    try {
      // this.TrnMainForm = this._fb.group({
      //     TRNMODE: ['', Validators.required],
      //     TRNAC: ['', Validators.required],
      //     BILLTO: ['', Validators.required],
      //     CHEQUENO: ['', Validators.required],
      //     CHEQUEDATE: ['', Validators.required],
      //     REMARKS: [''],
      // });

      if (this.TrnMainObj.Mode == 'VIEW') {
        this.viewMode = true;
        this.TrnMainForm.get('TRNMODE')?.disable();
        this.TrnMainForm.get('TRNAC')?.disable();
        this.TrnMainForm.get('BILLTO')?.disable();
        this.TrnMainForm.get('CHEQUENO')?.disable();
        this.TrnMainForm.get('CHEQUEDATE')?.disable();
        this.TrnMainForm.get('REMARKS')?.disable();
      }

      this.TrnMainForm.valueChanges.subscribe((form) => {
        this.TrnMainObj.TRNMODE = form.TRNMODE;
        this.TrnMainObj.TRNAC = form.TRNAC;
        this.TrnMainObj.BILLTO = form.BILLTO;
        this.TrnMainObj.CHEQUENO = form.CHEQUENO;
        this.TrnMainObj.CHEQUEDATE = form.CHEQUEDATE;
        this.TrnMainObj.REMARKS = form.REMARKS;
        console.log({ trnmain: this._transactionService.TrnMainObj });
      });

      // this.Suppliers = this.acList.filter(x => x.PType == 'V');
      // this.Customers = this.acList.filter(x => x.PType == 'C');
      // this.cashAndBankList = this.acList.filter(x => x.MAPID == 'C' || x.MAPID == 'B');
      // this.cashList = this.acList.filter(x => x.MAPID == 'C');
      // this.bankList = this.acList.filter(x => x.MAPID == 'B');
      if (this.voucherType == VoucherTypeEnum.ReceiveVoucher) {
        this.TrnMainObj.TRNMODE = 'Party Receipt';
        this.VoucherTypeChangeEvent('Party Receipt');
      } else if (this.voucherType == VoucherTypeEnum.PaymentVoucher) {
        this.TrnMainObj.TRNMODE = 'Party Payment';
        this.VoucherTypeChangeEvent('Party Payment');
      } else {
        this.VoucherTypeChangeEvent('');
      }

      if (this.TrnMainObj.Mode == 'EDIT' || this.TrnMainObj.Mode == 'VIEW') {
        this._transactionService.loadDataObservable.subscribe((data: any) => {
          try {
            this.TrnMainForm.patchValue({
              TRNMODE: data.TRNMODE,
              TRNAC: data.TRNAC,
              BILLTO: data.BILLTO,
              CHEQUENO: data.CHEQUENO,
              CHEQUEDATE: data.CHEQUEDATE,
              REMARKS: data.REMARKS,
            });
            this.VoucherTypeChangeEvent(data.TRNMODE);
          } catch (e) {
            console.log({ errorOnLoad: e });
          }
        });
      } else {
        // this.mode = "add";
        // this.modeTitle = "Add ";
        // this.initialTextReadOnly = false;
        // const uuidV1 = require('uuid/v1');
        // this.guid = uuidV1();
        // console.log({ newJournal: this.guid });
        // this.trnMode = "NEW";
        // this.TrnMainForm.get("DIVISION").setValue(this.settingService.appSetting.DefaultDivision.value);
        // this.masterService.getCurrentDate().subscribe(date => { this.TrnMainForm.get('TRNDATE').setValue(date.Date.substring(0, 10)); this.changeEntryDate(date.Date.substring(0, 10), "AD"); this.TrnMainForm.get('TRN_DATE').setValue(date.Date.substring(0, 10)); this.changeTrnDate(date.Date.substring(0, 10), "AD"); }, error => {
        //     console.log({ errorGetCurrentDate: error });
        //     this.masterService.resolveError(error, "AddIncomeVoucher - getCurrentDate");
        // });
        if (this.voucherType == VoucherTypeEnum.ReceiveVoucher) {
          this.TrnMainForm.patchValue({ TRNMODE: 'Party Receipt' });
        } else if (this.voucherType == VoucherTypeEnum.PaymentVoucher) {
          this.TrnMainForm.patchValue({ TRNMODE: 'Party Payment' });
        }
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  getAccountList(voucherType: string) {
    if (voucherType == 'Party Payment') {
      this.masterService
        .getAccount('IncomeVoucher-account')
        .pipe(
          map((data: any) => {
            var fil = data.filter(
              (ac: any) =>
                ac.PType == 'V' || ac.PType == 'C' || ac.PType == 'CC'
            );
            return fil;
          })
        )
        .subscribe((res: Array<TAcList>) => {
          this._transactionService.accountListSubject.next(res);
          console.log({
            partyPayment: res,
            acountsubject:
              this._transactionService.accountListSubject.getValue(),
          });
        });
    } else if (voucherType == 'Expenses Voucher') {
      this.masterService
        .getAccount('IncomeVoucher-Expenses')
        .pipe(
          map((data: any) => {
            var fil = data.filter(
              (ac: any) =>
                ac.PType != 'C' && ac.PType != 'V' && ac.PType != 'CC'
            );
            return fil;
          })
        )
        .subscribe((res: any) => {
          console.log({ expenses: res });
          this._transactionService.accountListSubject.next(res);
        });
    } else if (voucherType == 'Party Receipt') {
      this.masterService
        .getAccount('IncomeVoucher-account')
        .pipe(
          map((data: any) => {
            var fil = data.filter(
              (ac: any) =>
                ac.PType == 'V' || ac.PType == 'CV' || ac.PType == 'C'
            );
            return fil;
          })
        )
        .subscribe((res: Array<TAcList>) => {
          this._transactionService.accountListSubject.next(res);
        });
    } else if (voucherType == 'Income Voucher') {
      this.masterService
        .getAccount('IncomeVoucher-Expenses')
        .pipe(
          map((data: any) => {
            var fil = data.filter(
              (ac: any) =>
                ac.PType != 'C' && ac.PType != 'V' && ac.PType != 'CC'
            );
            return fil;
          })
        )
        .subscribe((res: any) => {
          this._transactionService.accountListSubject.next(res);
        });
    } else {
      this.masterService
        .getAccount('IncomeVoucher-default')
        .subscribe((res: any) => {
          this._transactionService.accountListSubject.next(res);
        });
    }
  }

  acCodeChange() {
    try {
      this.TrnMainForm.get('TRNAC')?.setValue(
        this.TrnMainForm.get('TRNAC')?.value
      );
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  acNameChange() {
    try {
      this.TrnMainForm.get('TRNAC')?.setValue(
        this.TrnMainForm.get('TRNAC')?.value
      );
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  VoucherTypeChangeEvent(value: any) {
    try {
      this.TrnMainObj.TRNMODE = value;
      this.getAccountList(value);
      if (value == 'Income Voucher') {
        this._transactionService.TableAcHeader = 'Income a/c';
        this.accountList = this.acList;
        this.trnaccountList = this.cashAndBankList;
        this.getAccountList(value);
      } else if (value == 'Party Receipt') {
        this._transactionService.TableAcHeader = 'Party/Income a/c';
        this.accountList = this.Suppliers;
        this.trnaccountList = this.cashAndBankList;
      } else if (
        value == 'Bank Withdraw Voucher' ||
        value == 'Bank Deposit Voucher'
      ) {
        this._transactionService.TableAcHeader = 'Bank a/c';
        this.accountList = this.bankList;
        this.trnaccountList = this.cashList;
      } else if (value == 'Cheque Encash') {
        this._transactionService.TableAcHeader = 'Cheque a/c';
        this.accountList = this.acList;
        this.trnaccountList = this.cashList;
      } else if (value == 'Expenses Voucher') {
        this._transactionService.TableAcHeader = 'Expenses a/c';
        this.accountList = this.acList;
        this.trnaccountList = this.cashAndBankList;
      } else if (value == 'Party Payment') {
        this._transactionService.TableAcHeader = 'Party Expenses a/c';
        this.accountList = this.Suppliers;
        this.trnaccountList = this.cashAndBankList;
      } else if (value == 'Cash Transfer') {
        this._transactionService.TableAcHeader = 'Transfer To';
        this.accountList = this.cashAndBankList;
        this.trnaccountList = this.cashAndBankList;
      } else if (value == 'Customer') {
        this._transactionService.TableAcHeader = 'Description';
        this.accountList = this.acList;
        this.trnaccountList = this.Customers;
      } else if (value == 'Supplier') {
        this._transactionService.TableAcHeader = 'Description';
        this.accountList = this.acList;
        this.trnaccountList = this.Suppliers;
      } else {
        this._transactionService.TableAcHeader = 'Description';
      }
      this.getAccountList(value);
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  // changeTrnDate(value, format: string) {
  //     try {
  //         var adbs = require("ad-bs-converter");
  //         if (format == "AD") {
  //             var adDate = (value.replace("-", "/")).replace("-", "/");
  //             var bsDate = adbs.ad2bs(adDate);
  //             this.TrnMainForm.get("BS_DATE").setValue(bsDate.en.year + '-' + (bsDate.en.month == '1' || bsDate.en.month == '2' || bsDate.en.month == '3' || bsDate.en.month == '4' || bsDate.en.month == '5' || bsDate.en.month == '6' || bsDate.en.month == '7' || bsDate.en.month == '8' || bsDate.en.month == '9' ? '0' + bsDate.en.month : bsDate.en.month) + '-' + (bsDate.en.day == '1' || bsDate.en.day == '2' || bsDate.en.day == '3' || bsDate.en.day == '4' || bsDate.en.day == '5' || bsDate.en.day == '6' || bsDate.en.day == '7' || bsDate.en.day == '8' || bsDate.en.day == '9' ? '0' + bsDate.en.day : bsDate.en.day));
  //         }
  //         else if (format == "BS") {
  //             var bsDate = (value.replace("-", "/")).replace("-", "/");
  //             var adDate = adbs.bs2ad(bsDate);
  //             this.TrnMainForm.get("TRN_DATE").setValue(adDate.year + '-' + ((adDate.month).toString().length == 1 ? '0' + adDate.month : adDate.month) + '-' + ((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
  //         }
  //     } catch (ex) {
  //         console.log(ex);
  //         alert(ex);
  //     }
  // }
  // clickTrnDate(value) {
  //     try {
  //         if (value != null && value != 0) {
  //             var adbs = require("ad-bs-converter");
  //             var bsDate = (value.replace("-", "/")).replace("-", "/");
  //             var adDate = adbs.bs2ad(bsDate);
  //             this.TrnMainForm.get("TRN_DATE").setValue(adDate.year + '-' + ((adDate.month).toString().length == 1 ? '0' + adDate.month : adDate.month) + '-' + ((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
  //         }
  //     } catch (ex) {
  //         console.log(ex);
  //         alert(ex);
  //     }
  // }

  // changeEntryDate(value, format: string) {
  //     try {
  //         var adbs = require("ad-bs-converter");
  //         if (format == "AD") {
  //             var adDate = (value.replace("-", "/")).replace("-", "/");
  //             var bsDate = adbs.ad2bs(adDate);
  //             this.TrnMainForm.get("BSDATE").setValue(bsDate.en.year + '-' + (bsDate.en.month == '1' || bsDate.en.month == '2' || bsDate.en.month == '3' || bsDate.en.month == '4' || bsDate.en.month == '5' || bsDate.en.month == '6' || bsDate.en.month == '7' || bsDate.en.month == '8' || bsDate.en.month == '9' ? '0' + bsDate.en.month : bsDate.en.month) + '-' + (bsDate.en.day == '1' || bsDate.en.day == '2' || bsDate.en.day == '3' || bsDate.en.day == '4' || bsDate.en.day == '5' || bsDate.en.day == '6' || bsDate.en.day == '7' || bsDate.en.day == '8' || bsDate.en.day == '9' ? '0' + bsDate.en.day : bsDate.en.day));
  //         }
  //         else if (format == "BS") {
  //             var bsDate = (value.replace("-", "/")).replace("-", "/");
  //             var adDate = adbs.bs2ad(bsDate);
  //             this.TrnMainForm.get("TRNDATE").setValue(adDate.year + '-' + ((adDate.month).toString().length == 1 ? '0' + adDate.month : adDate.month) + '-' + ((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
  //         }
  //     } catch (ex) {
  //         console.log(ex);
  //         alert(ex);
  //     }
  // }
  // clickEntryDate(value) {
  //     try {
  //         if (value != null && value != 0) {
  //             var adbs = require("ad-bs-converter");
  //             var bsDate = (value.replace("-", "/")).replace("-", "/");
  //             var adDate = adbs.bs2ad(bsDate);
  //             this.TrnMainForm.get("TRNDATE").setValue(adDate.year + '-' + ((adDate.month).toString().length == 1 ? '0' + adDate.month : adDate.month) + '-' + ((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
  //         }
  //     } catch (ex) {
  //         console.log(ex);
  //         alert(ex);
  //     }
  // }

  // onSave() {
  //     //validate before Saving
  //     try {
  //         this.onSaveClicked();
  //     } catch (ex) {
  //         console.log(ex);
  //         alert(ex);
  //     }
  // }

  // onSaveClicked() {
  //     try {
  //         console.log("submit call");
  //         if (this.voucherType == VoucherTypeEnum.PaymentVoucher) {
  //             if (this.TrnTranList[this.TrnTranList.length - 1].AccountItem.ACID == null || this.TrnTranList[this.TrnTranList.length - 1].DRAMNT == null) {
  //                 this.TrnTranList.splice((this.TrnTranList.length - 1), 1);
  //             }
  //             for (var t in this.TrnTranList) {
  //                 if (this.TrnTranList[t].AccountItem.HASSUBLEDGER == 1 && (this.TrnTranList[t].SubledgerTranList[this.TrnTranList[t].SubledgerTranList.length - 1].SubledgerItem.ACID == null || this.TrnTranList[t].SubledgerTranList[this.TrnTranList[t].SubledgerTranList.length - 1].DRAMNT == null)) {
  //                     this.TrnTranList[t].SubledgerTranList.splice((this.TrnTranList[t].SubledgerTranList.length - 1), 1);
  //                 }
  //             }
  //         } else if (this.voucherType == VoucherTypeEnum.ReceiveVoucher) {
  //             if (this.TrnTranList[this.TrnTranList.length - 1].AccountItem.ACID == null || this.TrnTranList[this.TrnTranList.length - 1].CRAMNT == null) {
  //                 this.TrnTranList.splice((this.TrnTranList.length - 1), 1);
  //             }
  //             for (var t in this.TrnTranList) {
  //                 if (this.TrnTranList[t].AccountItem.HASSUBLEDGER == 1 && (this.TrnTranList[t].SubledgerTranList[this.TrnTranList[t].SubledgerTranList.length - 1].SubledgerItem.ACID == null || this.TrnTranList[t].SubledgerTranList[this.TrnTranList[t].SubledgerTranList.length - 1].CRAMNT == null)) {
  //                     this.TrnTranList[t].SubledgerTranList.splice((this.TrnTranList[t].SubledgerTranList.length - 1), 1);
  //                 }
  //             }
  //         }

  //         let transaction = <TrnMain>{}
  //         transaction.Mode = this.trnMode;
  //         transaction.VCHRNO = this.TrnMainForm.value.VCHRNO,
  //             transaction.CHALANNO = this.TrnMainForm.value.CHALANNO,
  //             transaction.TRN_DATE = this.TrnMainForm.value.TRN_DATE,
  //             transaction.BS_DATE = this.TrnMainForm.value.BS_DATE,
  //             transaction.TRNDATE = this.TrnMainForm.value.TRNDATE,
  //             transaction.BSDATE = this.TrnMainForm.value.BSDATE,
  //             transaction.REMARKS = this.TrnMainForm.value.REMARKS,
  //             transaction.DIVISION = this.TrnMainForm.value.DIVISION,
  //             transaction.TRNMODE = this.TrnMainForm.value.TRNMODE,
  //             transaction.TRNAC = this.TrnMainForm.value.TRNAC,
  //             transaction.BILLTO = this.TrnMainForm.value.BILLTO,
  //             transaction.CHEQUENO = this.TrnMainForm.value.CHEQUENO,
  //             transaction.CHEQUEDATE = this.TrnMainForm.value.CHEQUEDATE,
  //             transaction.VoucherPrefix = this.prefix.VNAME;
  //         transaction.BS_DATE = null;
  //         transaction.BSDATE = null;
  //         transaction.VoucherType = this.voucherType;
  //         // if (this.voucherType == VoucherTypeEnum.PaymentVoucher) {
  //         //     transaction.VoucherType = VoucherTypeEnum.PaymentVoucher;
  //         // }
  //         transaction.TrntranList = this.TrnTranList;
  //         console.log({ tosubmit: transaction });

  //         // let sub = this.voucherService.saveJournal(this.mode, this.guid, transaction)
  //         let sub = this.masterService.saveTransaction(this.mode, transaction)
  //             .subscribe(data => {
  //                 if (data.status == 'ok') {
  //                     this.router.navigate([this.returnUrl]);
  //                 }
  //             },
  //             error => { alert(error) }
  //             );
  //         this.subcriptions.push(sub);
  //     }
  //     catch (e) {
  //         alert(e);
  //     }
  // }

  ngOnDestroy() {
    try {
      this.subcriptions.forEach((subs) => {
        subs.unsubscribe();
      });
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  // prefixChanged(prefix) {
  //     try {
  //         this.prefix = prefix;
  //         if (this.mode == 'add') {
  //             var tMain = { VoucherPrefix: prefix.VNAME };
  //             this.masterService.getVoucherNo(tMain).subscribe(res => {
  //                 if (res.status == "ok") {
  //                     let TMain = <TrnMain>res.result;
  //                     this.TrnMainObj.VCHRNO = TMain.VCHRNO.substr(2, TMain.VCHRNO.length - 2)
  //                     this.TrnMainForm.patchValue({
  //                         VCHRNO: TMain.VCHRNO.substr(2, TMain.VCHRNO.length - 2),
  //                         CHALANNO: TMain.CHALANNO,
  //                     });
  //                 }
  //                 else {
  //                     alert("Failed to retrieve VoucherNo")
  //                     console.log(res);
  //                 }
  //             });
  //         }
  //     } catch (ex) {
  //         console.log(ex);
  //         alert(ex);
  //     }
  // }
}
